
    export const UserSearchStyles = {
        marginBottom: (theme) => theme.spacing(3),
        width: '65%'
    }
